<template>

  <body class="dx-viewport">
    <DxDataGrid ref="dataGridRef" :allowColumnReordering="true" :data-source="dsRoluriUtilizatori"
      :allowColumnResizing="true" key-expr="ID" :columnAutoWidth="false" :columnMinWidth="50"
      :columnResizingMode="'nextColumn'" :show-borders="true" :syncLookupFilterValues="false"
      :filter-sync-enabled="true" show-row-lines="true" row-alternation-enabled="true" show-column-lines="false"
      @row-inserting="onRowInserting" @row-removing="onRowRemoving" class="border">
      <DxSelection mode="single" />
      <DxFilterRow :visible="true" />
      <DxPaging :page-size="5" :page-index="1" />
      <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
      <DxSorting mode="multiple" />
      <DxStateStoring :enabled="true" :filterValue="false" storage-key="RoluriUtilizatori" />
      <DxToolbar>
        <DxItem>
          <template #default>
            <DxButton icon="add" type="success" @click="onAddClick" />
          </template>
        </DxItem>
        <DxItem>
          <template #default>
            <DxButton icon="refresh" @click="onRefreshClick" />
          </template>
        </DxItem>
      </DxToolbar>
      <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup" @click="onRowRemoving">
        <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="450" :height="400">
          <DxToolbarItem :template="customTitleTemplate" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
        </DxPopup>
        <DxFormGrid>
          <DxItem :col-span="1" :col-count="1" item-type="group">
            <DxItem :col-span="1" :col-count="1" item-type="group">
              <v-select :items="unallocatedUsers" item-title="Username" item-value="ID" prepend-inner-icon="mdi-account"
                variant="outlined" placeholder="Selectați utilizatorul" v-model="selectedUser">
              </v-select>
            </DxItem>
            <DxItem data-field="UserID" :editor-options="{ width: 410 }" :label="{ text: 'Utilizator' }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
            <DxItem data-field="RolID" :editor-options="{ width: 410 }" :label="{ text: 'Rol' }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>

          </DxItem>
        </DxFormGrid>
      </DxEditing>
      <DxColumn data-field="UserID" :visible="false" />
      <DxColumn data-field="Username" caption="Utilizator" />
      <DxColumn data-field="RolID" :visible="false" />

    </DxDataGrid>
    <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false" :showTitle="true"
      :width="450" :height="400">
      <template #title>
        <div
          style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
          Adăugare</div>
      </template>
      <div>
        <DxForm :formData="formData">
          <DxItem :col-span="1" :col-count="1" item-type="group">
            <DxItem dataField="UserID" isRequired="true" :label="{ text: 'Utilizator' }">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
            <DxItem dataField="RolID" isRequired="true" :label="{ text: 'Rol' }" />
            <DxValidationRule>
              <DxRequiredRule />
            </DxValidationRule>
          </DxItem>
        </DxForm>
        <div style="display: flex; justify-content: flex-end; gap: 8px;">
          <DxButton text="Salvează" type="success" width="100" @click="onSaveAdd" />
          <DxButton text="Închide" type="danger" width="100" @click="onCancel" />
        </div>
      </div>
    </DxPopupAdd>
  </body>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';

import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar,
  DxEditing,
  DxPopup,
  DxItem as DxItemForm,
  DxForm as DxFormGrid,
  DxValidationRule,
  DxRequiredRule,
  DxLookup
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import notify from 'devextreme/ui/notify';
import { locale, loadMessages } from 'devextreme/localization';
import AUTH_Roluri from '@/services/AUTH/AUTH_Roluri';
import ResponseData from '@/types/responseData';
import RoluriUtilizatori from '@/types/auth/roluriUtilizatori';
import AUTH_RoluriUtilizatori from '@/services/AUTH/AUTH_RoluriUtilizatori';
import Roluri from '@/types/auth/roluri';
import UserCompanyService from '@/services/Administrare/UserCompanyService';
import UserService from '@/services/Administrare/UserService';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '../../settings/appSettings'
export default defineComponent({
  components: {
    DxToolbar,
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxStateStoring,
    DxLoadPanel,
    DxPaging,
    DxButton,
    DxItem,
    DxPopup,
    DxForm,
    DxLabel,
    DxEditing,
    DxPopupAdd,
    DxToolbarItem,
    DxItemForm,
    DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
    DxLookup
  },
  data() {
    return {
      unallocatedUsers: [],
      selectedUser: null,
      dsRoluriUtilizatori: {} as ODataStore,
      dsRoluri: [] as any[],
      isModalVisible: false,
      formData: {
        UserID: '',
        RolID: '',
      },
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
      dataGridRef: ref<DxDataGrid | null>(null),
      successButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.onSaveEdit();
        },
      },
      dangerButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancelEdit();
        },
      },
      customTitleTemplate() {
        return `
        <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:570px; color: white;
        font-weight: bold;  padding: 12px; padding-right: 300px;  position: relative;  left: 30px;">
          Editare
        </div>
      `;
      },
    };
  },
  props: {
    RolID: String
  },
  watch: {
    RolID: {
      immediate: true,
      handler(newVal) {

        this.createODataContext(newVal);
      },
    },
  },

  methods: {
    //     getUserCompanies() {
    //   UserCompanyServices.getAll()
    //     .then((response: ResponseData) => {
    //       this.companies = response.data;
    //     })
    //     .catch((e: Error) => {
    //       console.log(e)
    //     });
    // },
    createODataContext(RolID) {

      this.dsRoluriUtilizatori = {
        store: new ODataStore({
          url: AppSetting.API_Url + 'AUTH_RoluriUtilizatori',
          key: 'ID',
          version: 4,
          fieldTypes: {
            RolID: "Guid",
            ID: "Guid"
          },
          beforeSend: (e) => {
            e.headers = {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
            };
          },
        }),
        filter: ['RolID', '=', RolID]
      };


    },

    getUser() {
      UserService.getUsersNotAdded()
        .then((response: ResponseData) => {
          this.unallocatedUsers = response.data;
        })
        .catch((e: Error) => {
          console.log(e)
        });
    },
    // getRoluriUtilizatori() {
    //   AUTH_RoluriUtilizatori.get()
    //     .then((response: ResponseData) => {
    //       this.dsRoluriUtilizatori = response.data;
    //     })
    //     .catch((e: Error) => {
    //       console.log(e)
    //     });
    // },
    getRoluri() {
      AUTH_Roluri.get()
        .then((response: ResponseData) => {
          this.dsRoluri = response.data;
        })
        .catch((e: Error) => {
          console.log(e)
        });
    },
    onAddClick() {
      this.isModalVisible = true;
    },
    onSaveAdd() {
      const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
      console.log(this.formData);
      const body = this.formData;
      AUTH_RoluriUtilizatori.save(body)
        .then((response) => {
          this.isModalVisible = false;
          notify('Datele au fost salvate cu succes!', 'success', 1000);
          this.formData = { Nume: '', Explicatie: '' };
          //this.getRoluriUtilizatori();
        })
        .catch((error) => {
          console.error(error);
          notify('Datele există deja!', 'error', 1000);
        });

    },
    onCancel() {
      this.isModalVisible = false;
    },
    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.dataGridRef?.instance;
      dataGrid.option('editing', {
        allowUpdating: true,
        allowDeleting: true,
        mode: 'popup',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",
        }
      });
    },
    onClick() {
      this.isModalVisible = true;
    },
    onColumnChooserClick() {
      const dataGrid = this.$refs.dataGrid.instance;
      dataGrid.showColumnChooser();
    },
    onRefreshClick() {
      //this.getRoluriUtilizatori();
      notify('Datele au fost actualizate cu succes!', 'success', 1000)
    },
    onSaveEdit() {


      const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();

      if (savePromise) {
        savePromise.then(() => {
          //this.getRoluriUtilizatori();
        }).catch((error) => {
          console.error("Eroare la salvare:", error);
        });
      }
    },
    onCancelEdit() {
      this.dataGridRef?.instance?.cancelEditData();
    },
    onRowRemoving(e: any) {
      e.cancel = new Promise((resolve) => {
        this.dataGridRef?.instance?.saveEditData();
        notify('Datele au fost șterse cu succes!', 'success', 1000);
        resolve(false);
      });
    },
    onRowInserting() {
      notify('Datele au fost adăugate cu succes!', 'success', 1000)
    },
  },
  mounted() {
    this.getRoluri();
    //this.getRoluriUtilizatori();
    this.createODataContext();
    this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
    this.setDeleteConfirmationMessage();
    loadMessages({
      "ro": {
        "Yes": "Da",
        "No": "Nu",
      }
    });
    locale('ro');
  },
});
</script>
<style scoped>
.border {
  border-radius: 8px;
}
</style>
